import { jsx as r, jsxs as p } from "react/jsx-runtime";
import { useState as N, useEffect as b } from "react";
import { Radio as x } from "./Radio.mjs";
const w = (u) => {
  const {
    error: i,
    message: o,
    helpText: n,
    name: s,
    reference: g,
    legend: c,
    options: t,
    onOptionSelected: d,
    testId: e
  } = u, [l, v] = N(null), f = (a) => {
    v(a.target.value);
  };
  b(() => {
    d == null || d(l);
  }, [l, d]);
  const C = [
    i && o ? "errorContainer" : "",
    n ? "helpContainer" : ""
  ].filter(Boolean).join(" "), h = t == null ? void 0 : t.map((a, m) => {
    const $ = `${s ?? "radio-option"}-${m}`;
    return /* @__PURE__ */ r(
      x,
      {
        id: $,
        name: s ?? "radio-option",
        value: a,
        label: a,
        checked: l === a,
        onChange: f,
        reference: g,
        testId: e
      },
      `option-${m}`
    );
  });
  return /* @__PURE__ */ p(
    "fieldset",
    {
      className: "Form-group",
      role: "radiogroup",
      "aria-invalid": i ? "true" : void 0,
      "aria-describedby": C || void 0,
      "data-testid": e ? `${e}-fieldset` : void 0,
      children: [
        c && /* @__PURE__ */ r(
          "legend",
          {
            className: "u-marginBottom8",
            "data-testid": e ? `${e}-legend` : void 0,
            children: c
          }
        ),
        i ? /* @__PURE__ */ r("div", { className: "RadioCheckbox-wrapper", children: h }) : h,
        i && o && /* @__PURE__ */ r("ul", { id: "errorContainer", children: /* @__PURE__ */ p(
          "li",
          {
            className: "Form-help Form-help--error",
            "data-testid": e ? `${e}-message` : void 0,
            children: [
              /* @__PURE__ */ r(
                "span",
                {
                  "data-testid": e ? `${e}-warning` : void 0,
                  "aria-hidden": "true",
                  children: "warning"
                }
              ),
              /* @__PURE__ */ r("span", { className: "u-hiddenVisually", children: "Error," }),
              /* @__PURE__ */ r("span", { children: o })
            ]
          }
        ) }),
        n && /* @__PURE__ */ r("ul", { id: "helpContainer", children: /* @__PURE__ */ r(
          "li",
          {
            className: "Form-help",
            "data-testid": e ? `${e}-helpText` : void 0,
            children: n
          }
        ) })
      ]
    }
  );
};
export {
  w as RadioGroup
};
//# sourceMappingURL=RadioGroup.mjs.map
